import { render, staticRenderFns } from "./CategoryView.vue?vue&type=template&id=017c60b5&scoped=true"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"
import style0 from "./CategoryView.vue?vue&type=style&index=0&id=017c60b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017c60b5",
  null
  
)

export default component.exports